import select2 from 'select2';

function initCategorySelect(root) {
  var category = root.querySelector('.js-ssc-category');
  if (!category || !$.fn || !$.fn.select2) return;
  var $category = $(category);
  if ($category.data('select2')) $category.select2('destroy');
  $category.select2({
    width: '100%',
    placeholder: $category.data('placeholder') || 'Type to find a category',
    allowClear: true,
    minimumResultsForSearch: 0,
    dropdownParent: $(root)
  });
}

function bindSupplierShopifyConnection() {
  var root = document.querySelector('#page-body .ssc');
  if (!root) return;

  var importForm = root.querySelector('#ssc-import');
  var details = importForm ? importForm.closest('details') : null;
  if (details) {
    details.addEventListener('toggle', function () {
      if (details.open) initCategorySelect(root);
    });
    if (details.open) initCategorySelect(root);
  } else {
    initCategorySelect(root);
  }

  root.addEventListener('click', function (event) {
    var toggle = event.target.closest('.ssc-toggle');
    if (!toggle || !root.contains(toggle)) return;
    var group = toggle.closest('.ssc-product');
    if (!group) return;
    group.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', group.classList.contains('is-open') ? 'true' : 'false');
  });

  var selectAll = root.querySelector('.ssc-select-all');
  if (selectAll) {
    selectAll.addEventListener('change', function () {
      var boxes = root.querySelectorAll('.ssc-product-check');
      Array.prototype.forEach.call(boxes, function (box) {
        if (!box.disabled) box.checked = selectAll.checked;
      });
    });
    root.addEventListener('change', function (event) {
      if (!event.target.classList.contains('ssc-product-check')) return;
      var boxes = root.querySelectorAll('.ssc-product-check:not(:disabled)');
      var checked = root.querySelectorAll('.ssc-product-check:not(:disabled):checked');
      selectAll.checked = boxes.length > 0 && checked.length === boxes.length;
    });
  }

  var previewForm = root.querySelector('.ssc-preview-form');
  if (previewForm) {
    previewForm.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var result = document.getElementById('ssc-preview-result');
      var button = previewForm.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      fetch(previewForm.action, {
        method: 'POST',
        body: new FormData(previewForm),
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html'
        }
      }).then(function (response) {
        if (response.headers.get('X-SSC-Preview') !== '1') throw new Error('preview');
        return response.text();
      }).then(function (html) {
        if (result) result.innerHTML = html;
      }).catch(function () {
        if (result) {
          result.innerHTML = '<div class="ssc-banner ssc-banner-alert">Preview could not be loaded. Try again.</div>';
        }
      }).then(function () {
        if (button) button.disabled = false;
      });
    });
  }

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindSupplierShopifyConnection);
} else {
  bindSupplierShopifyConnection();
}
